import { render } from "./ReasonsList.vue?vue&type=template&id=71648ffb"
import script from "./js/reasonsList.js?vue&type=script&lang=js&external"
export * from "./js/reasonsList.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__